import { BrowserRouter } from 'react-router-dom';
import Router from './Router';
import './i18n';

const App = () => {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
};

export default App;
